module.exports = __webpack_public_path__ + "./favicons/apple-icon-60x60.png";